import classes from './table-actions.module.scss';
import { useUserManagement } from '../../../../../../../Hooks';

import { Button, Input, Space } from 'antd';
import { IoMdRefresh, IoMdSearch } from "react-icons/io";
import { useTranslation } from 'react-i18next';

interface IProps {
  userManagement: ReturnType<typeof useUserManagement>;
}

export default function TableActions({ userManagement }: IProps) {
  const { t } = useTranslation();
  const searchHandler = (searchTerms: string) => (
    userManagement.updateState({ searchTerms })
  )

  const refreshHandler = () => (
    userManagement.fetchUsers()
  )

  return (
    <div className={classes.wrapper}>
      <Input
        value={userManagement.state.searchTerms}
        onChange={e => searchHandler(e.target.value)}
        prefix={<IoMdSearch color='rgb(90, 90, 90)' size={21} />}
        placeholder={t('settings.search')}
      />
      <Space>
        <Button
          onClick={refreshHandler}
          icon={<IoMdRefresh size={19} />}
        >
          {t('settings.refresh')}
        </Button>
      </Space>
    </div>
  )
}